
  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header title">¡Todavía estas a tiempo!</h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <div class="container hotel">
        <ng-template #noImage>
          <div class="left" [ngClass]="brandImage"></div>
        </ng-template>
        <div
          *ngIf="dialogData.hotel?.images?.length > 0; else noImage"
          [ngStyle]="{
            'background-image': 'url(' + urlResize + dialogData.hotel.images[0].url + ')',
          }"
          class="left"
        ></div>
        <div class="right">
          <span
            class="title"
            i18n="@@user_inactivity_aprovecha_esta_oferta_antes_de_que_se_agote"
            >¡APROVECHÁ ESTA OFERTA ANTES DE QUE SE AGOTE!</span
          >
          <p class="name">{{ dialogData.hotel.name }}</p>
          <div class="subtitle-content">
            <div>
              <mb-stars-rating [rating]="dialogData.hotel.stars"></mb-stars-rating>
              <div class="list">
                <ng-container
                  *ngFor="let amenity of dialogData.hotel.amenities | slice: 0 : 6"
                >
                  <ng-template #amenityTooltip>
                    {{ amenity.description }}
                  </ng-template>
                  <mb-icon
                    class="amenity-icon"
                    [icon]="amenity.icon"
                    [mb-tooltip]="amenityTooltip"
                    mbTooltipColor="dark"
                    mbTooltipPosition="below"
                  ></mb-icon>
                </ng-container>
              </div>
            </div>
            <div class="right-align">
              <mb-advice
                *ngIf="
                  dialogData.hotel.rate.price.discount.percentage >= 5 &&
                  dialogData.hotel.rate.price.discount.amount
                "
                color="success"
                align="right"
              >
                <span>{{ dialogData.hotel.rate.price.discount.percentage }}% OFF</span>
              </mb-advice>
            </div>
          </div>
          <button
            mb-button
            mb-button-small
            variant="principal"
            color="primary"
            (click)="goToDetail()"
            i18n="@@ver_alojamiento"
          >
            Ver alojamiento
          </button>
          <span class="lastest-rooms" i18n="@@user_inactivity_ultimas_x_habitaciones"
            >Últimas {{ dialogData.hotel.rate.latest_rooms }} habitaciones</span
          >
        </div>
      </div>
    </div>
  </mb-dialog-body>

